const ConditionalProfileCard = importCond<
	typeof import('./main.tsx'),
	typeof import('./async.tsx')
>('empanada_profilecard_trial_sync_trigger_import', './main.tsx', './async.tsx');

export default ConditionalProfileCard;
